module.exports = __webpack_public_path__ + "img/other_geted@2x.66d1db53.png";